export function scrollTo(
  element: HTMLElement | undefined | null,
  scrollToBottom = false
) {
  let offsetTop = 0;
  const offsetHeight = element ? element.offsetHeight : 0;

  while (element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent as HTMLElement;
  }

  return window.scrollTo(
    0,
    scrollToBottom ? offsetTop + offsetHeight : offsetTop
  );
}
